import React, { Fragment, useEffect, useState } from "react";

import { Slider, SliderProps } from "@mui/material";
import { Box } from "@mui/system";

import Text from "@src/sharedComponents/Typography/Text";

import styles from "./RangeSlider.module.css";

type RangeSliderValue = [number, number] | number[];

interface RangeSliderProps extends SliderProps {
  startAdornment?: string;
  endAdornment?: string;
  min?: number;
  max?: number;
  value?: RangeSliderValue;
  onChange?: (
    event: Event | React.SyntheticEvent,
    value: number | number[],
    activeThumb: number
  ) => void;
  onChangeCommitted?: (
    event: Event | React.SyntheticEvent,
    value: number | number[]
  ) => void;
}

const RangeSlider: React.FC<RangeSliderProps> = ({
  min = 1,
  max = 10000,
  value,
  onChange,
  onChangeCommitted,
  valueLabelDisplay = "off",
  startAdornment,
  endAdornment,
}) => {
  const [internalValue, setInternalValue] = useState<RangeSliderValue>([
    min,
    max,
  ]);

  useEffect(() => {
    if (value) {
      setInternalValue(value);
    }
  }, [value]);

  const handleChangeCommitted = (
    event: Event | React.SyntheticEvent,
    newValue: number | number[]
  ) => {
    if (Array.isArray(newValue) && newValue.length === 2) {
      setInternalValue(newValue);
      onChangeCommitted?.(event, newValue);
    }
  };

  const handleChange = (
    _event: Event | React.SyntheticEvent,
    newValue: number | number[]
  ) => {
    if (Array.isArray(newValue) && newValue.length === 2) {
      setInternalValue(newValue);
      onChange?.(_event, newValue, 0);
    }
  };

  return (
    <Fragment>
      <Slider
        min={min}
        max={max}
        value={internalValue}
        onChangeCommitted={handleChangeCommitted}
        onChange={handleChange}
        valueLabelDisplay={valueLabelDisplay}
        classes={{
          root: styles.sliderRoot,
          thumb: styles.sliderThumb,
          track: styles.sliderTrack,
          rail: styles.sliderRail,
          mark: styles.sliderMark,
        }}
      />
      <Box display="flex" justifyContent="space-between" mt={1}>
        <Text variant="bodySmall">
          {startAdornment}
          {internalValue[0]}
          {endAdornment}
        </Text>
        <Text variant="bodySmall">
          {startAdornment}
          {internalValue[1]}
          {endAdornment}
        </Text>
      </Box>
    </Fragment>
  );
};

export default RangeSlider;
